module.exports = __webpack_public_path__ + "img/2024_NG.103afbef.png";